import { Stack } from '@mui/material';

import ForwardingAddressSettingsCard from 'src/sections/admin/organization/settings/components/forwarding-address-settings';

import InboundEmailActivityView from './inbound-email-activity-view';

// App Imports (JT1-1287): the inbound-email forwarding-address settings and the received-mail
// activity log, consolidated into a single Organisation tab so everything lives together.
export default function AppImportsView() {
  return (
    <Stack spacing={3}>
      <ForwardingAddressSettingsCard />
      <InboundEmailActivityView embedded />
    </Stack>
  );
}
